import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type RuntimeEnv = 'DEV' | 'QA';

export type RuntimeUrlKey =
  | 'SIMULADOR_AGORA'
  | 'VTEX'
  | 'MAINTAINER'
  | 'INDXP'
  | 'API'
  | 'PAY_BUTTON';

const STORAGE_KEY = 'demo.runtimeEnv';

const URLS: Record<RuntimeUrlKey, Record<RuntimeEnv, string>> = {
  SIMULADOR_AGORA: {
    DEV: 'https://dev.pagoweb.pe',
    QA: 'https://qa.pagoweb.pe',
  },
  VTEX: {
    DEV: 'https://dev.pagoweb.pe/vtex',
    QA: 'https://qa.pagoweb.pe/vtex',
  },
  MAINTAINER: {
    DEV: 'https://dev.api.epago.pe',
    QA: 'https://qas.api.epago.pe',
  },
  INDXP: {
    DEV: 'https://indxp-processor-eq3wxvapzq-ue.a.run.app',
    QA: 'https://indxp-processor-bhap7t33ia-ue.a.run.app',
  },
  API: {
    DEV: 'https://dev.api.epago.pe',
    QA: 'https://qas.api.epago.pe',
  },
  PAY_BUTTON: {
    DEV: 'https://dev.pay.button.epago.pe',
    QA: 'https://qas.pay.button.epago.pe',
  },
};

function readStoredEnv(): RuntimeEnv {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'DEV' || raw === 'QA') return raw;
  } catch {
    /* ignore */
  }
  return 'QA';
}

@Injectable({ providedIn: 'root' })
export class RuntimeEnvService {
  private readonly envSubject = new BehaviorSubject<RuntimeEnv>(readStoredEnv());
  readonly env$ = this.envSubject.asObservable();

  get(): RuntimeEnv {
    return this.envSubject.value;
  }

  set(env: RuntimeEnv): void {
    if (env !== 'DEV' && env !== 'QA') return;
    try {
      localStorage.setItem(STORAGE_KEY, env);
    } catch {
      /* ignore */
    }
    this.envSubject.next(env);
  }

  url(key: RuntimeUrlKey): string {
    return URLS[key][this.get()];
  }

  /** SDK Form `environment` string for Epago.Form */
  sdkEnvironment(): 'development' | 'quality' {
    return this.get() === 'DEV' ? 'development' : 'quality';
  }
}
